import HundredBricksAPIError from '../../../HundredBricksAPIError';
class RejectPaymentPlanError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RejectPaymentPlanError', ...args);
    }
}
export default RejectPaymentPlanError;
